import { userPreferencesApi } from './userPreferencesApiBase';
import { UserPreferencesView } from './types';

export const userPreferencesQueriesApi = userPreferencesApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get the signed-in user's saved preferences (empty defaultCenters if none saved yet)
    getMyPreferences: builder.query<UserPreferencesView, void>({
      query: () => 'UserPreferences/mine',
      providesTags: ['UserPreferences'],
    }),
  }),
});

export const { useGetMyPreferencesQuery } = userPreferencesQueriesApi;
